import { render, staticRenderFns } from "./UplodeImage2.vue?vue&type=template&id=2fd2e630&scoped=true&"
import script from "./UplodeImage2.vue?vue&type=script&lang=js&"
export * from "./UplodeImage2.vue?vue&type=script&lang=js&"
import style0 from "./UplodeImage2.vue?vue&type=style&index=0&id=2fd2e630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd2e630",
  null
  
)

export default component.exports